// Semantic chart colors stay stable across tenants and translated labels.
export const chartColors = {
  done: '#4DC55C',
  open: '#F0AC19',
  rejected: '#AAAAAA',
  new: '#0AB7E2',
  danger: '#E5634F'
} as const;

export function deviationStatusColor(status: string): string {
  switch (
    typeof status === 'string'
      ? status.toUpperCase().replace(/_CASES$/, '')
      : ''
  ) {
    case 'DONE':
      return chartColors.done;
    case 'OPEN':
      return chartColors.open;
    case 'NEW':
      return chartColors.new;
    default:
      return chartColors.rejected;
  }
}
